import { useContext, useEffect, useState } from 'react'
import { ConfigProvider, Form } from 'antd';
import { Input, Button, Typography, Select } from "mobily-ui-library/lib";
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';
import FTTHRouter from '../../assets/FTTHRouter.svg';
import { JSEncrypt } from 'jsencrypt';

import { getNationality, initiateLogin } from '../../api/api';

import './TrackRequestLogin.scss';

const win: any = window;

function TrackRequestLogin() {
    const { t } = useTranslation();

    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, lang } = state;
    const direction = rtl ? 'rtl' : 'ltr';

    const [form] = Form.useForm();
    const initialValues = {};
    const [isFormValid, setIsFormValid] = useState(false);
    const [countryList, setCountryList] = useState<any>([]);
    const [countryName, setCountryName] = useState<any>('');
    const [nationality, setNationality] = useState<any>({});

    useEffect(() => {
        dispatch({ type: 'SET_LOADER', payload: true });
        setCountryName('');
        getNationality()
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    dispatch({ type: 'SET_LOADER', payload: false });
                    const parsedCountry: any = JSON.parse(res?.data?.data?.NATIONALITIES);
                    const listData = parsedCountry.map((c: any) => {
                        return {
                            id: c.key,
                            text: rtl ? c?.arabicName : c?.englishName
                        }
                    })
                    setCountryList(listData);
                }
            }).catch(err => {
                console.log(err)
                window.location = win['base_portal_url'] + win['errorPageURL']
            })
    }, [])

    const handleSubmitForm = async (values: any) => {
        try {
            dispatch({ type: 'SET_LOADER', payload: true });
            const cemPublicKey = win['PK'];
            const jsencrypt = new JSEncrypt();
            jsencrypt.setPublicKey(cemPublicKey);

            const mobileNumber = jsencrypt.encrypt(values.MobileNumber);
            const idNumber = jsencrypt.encrypt(values.NationalId);

            const data: any = {
                version: "v1",
                journey: "LOGIN",
                operation: "QUICK_LOGIN",
                language: lang,
                extraInfo: [
                    {
                        key: "ACCOUNT_NUMBER",
                        value: mobileNumber
                    },
                    {
                        key: "ACCOUNT_TYPE",
                        value: "MSISDN"
                    },
                    {
                        key: "ID_NUMBER",
                        value: idNumber
                    },
                    {
                        key: "NATIONALITY",
                        value: nationality?.id
                    },
                    {
                        key: "LOGIN_TYPE",
                        value: "QUICK"
                    }
                ]
            }

            const res = await initiateLogin(data);
            dispatch({ type: "SET_LOADER", payload: { loading: false } });
            if (res.status === 200 && res.data) {
                if (res?.data?.status?.sourceCode === 'MAPI-000') {
                    window.scroll({ top: 0, left: 0, behavior: "smooth" });
                    dispatch({ type: "SET_MSISDN", payload: { msisdn: values.MobileNumber, refId: res.data.data.refId, smsSentTo: res.data.data.accountNumber, nationalId: values.NationalId } });
                    dispatch({ type: 'UPDATE_PAGE', payload: 'TR_OTP' });
                } else {
                    window.location = win['base_portal_url'] + win['errorPageURL']
                }
            } else {
                window.location = win['base_portal_url'] + win['errorPageURL']
            }
        } catch (err) {
            window.location = win['base_portal_url'] + win['errorPageURL']
        };
    }

    const onValuesChange = () => {
        setTimeout(() => {
            setIsFormValid((form.isFieldsTouched(['NationalId', 'MobileNumber', 'SelectCountry'], true)) && form.getFieldsError().every(({ errors }) => errors.length === 0))
        }, 0);
    };

    const handleSelectCountry = (e: string) => {
        setCountryName(e);
        const filterCountry = countryList.filter((it: any) => {
            if (it.text === e) {
                return it;
            }
        })[0]
        setNationality(filterCountry);
    }

    return (
        <div className='DCS__Section '>
            <section className='DCS__HeadingSection'>
                <img src={FTTHRouter} alt='success' className='router-img' />
                <div className='DCS__Subheading'>
                    <Typography className='TO_title'>{t('Check_new_FTTH_Coverage_status')}</Typography>
                    <Typography className='subTitle'>{t('Please_enter_the_details_you_used_for_the_request_to_continue')}</Typography>
                </div>
                <div className='Track__LoginForm'>
                    <ConfigProvider direction={direction}>
                        <Form form={form} name="control-ref" onFinish={handleSubmitForm} initialValues={initialValues} onValuesChange={onValuesChange} className='track-login-form'>
                            <Form.Item
                                hasFeedback={false}
                                name='NationalId'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('Saudi_ID_Iqama')}` },
                                    {
                                        message: t('IDNumber_validation'),
                                        pattern: /^[0-9]{1,10}$/
                                    }
                                ]}
                            >
                                <Input
                                    rtl={rtl}
                                    placeholder="XX XX XX XX XX"
                                    headingleft={t('National_ID')}
                                    labelleft={t('Saudi_ID_or_Iqama')}
                                    maxLength={10}
                                />
                            </Form.Item>
                            <Form.Item
                                hasFeedback={false}
                                name='MobileNumber'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('Mobile_number')}` },
                                    {
                                        message: t('MobileNumber_validation'),
                                        pattern: /^((9665)([0-9]{8}))$/
                                    }
                                ]}
                            >
                                <Input
                                    rtl={rtl}
                                    placeholder='9665XXXXXXXX'
                                    headingleft={t('Absher_contact_number')}
                                    labelleft={t('This_must_number_linked')}
                                    maxLength={12}
                                />
                            </Form.Item>
                            <Form.Item
                                hasFeedback={true}
                                initialValue={countryList}
                                className='form__fieldItem'
                                name='SelectCountry'
                            >
                                <Select
                                    id={`selectCountry_${countryName}`}
                                    rtl={rtl}
                                    value={countryName}
                                    headingLeft={t('nationality')}
                                    placeholder={t("select")}
                                    onChange={handleSelectCountry}
                                    options={countryList}
                                    showSearch={true}
                                />
                            </Form.Item>
                            <Form.Item>
                                <div className='form__StickyContainer'>
                                    <div className='FSTC__Box'>
                                        <Button
                                            primary={true}
                                            rtl={rtl}
                                            variant={isFormValid ? 'default' : 'disabled'}
                                            htmlType={'submit'}
                                        >
                                            {t('CONTINUE')}
                                        </Button>
                                    </div>
                                </div>
                            </Form.Item>
                        </Form>
                    </ConfigProvider>
                </div>
            </section>
        </div>
    )
}

export default TrackRequestLogin